import { useCallback } from "react";
export function useCombinedRef(ownRef, forwardedRef) {
    return useCallback((element) => {
        ownRef.current = element;
        if (typeof forwardedRef === "function") {
            forwardedRef(element);
        }
        else if (forwardedRef) {
            forwardedRef.current = element;
        }
    }, [forwardedRef, ownRef]);
}
